import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    public showConfirmDialog(message: string, params: any, title?: string, titleParams?: any): Observable<boolean> {
        return from(this.confirmDialog(message, params, title, titleParams))
            .pipe(map((result: SweetAlertResult) => !result.dismiss));
    }

    private async confirmDialog(message: string, params: any, title?: string, titleParams?: any): Promise<SweetAlertResult> {
        return Swal.fire({
            title,
            text: message,
            icon: 'info',
            heightAuto: false,
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: '<i class="fa fa-check"></i>Confirmer'
        });
    }

    public showInformDialog(message: string, params: any, title?: string, titleParams?: any): Observable<boolean> {
        return from(this.informDialog(message, title))
            .pipe(map((result: SweetAlertResult) => !result.dismiss));
    }

    private async informDialog(message: string, title?: string): Promise<SweetAlertResult> {
        return Swal.fire({
            title,
            text: message,
            icon: 'info',
            heightAuto: false,
            confirmButtonText: '<i class="fa fa-check"></i>Ok'
        });
    }
}
